<template>
  <modal name="success">
    <!-- if no connections app -->
    <div v-if="patient.no_connections_app">
      <h1 class="text-xl font-bold mb-8" :class="[!isCompanion ? 'light-blue' : 'green']">{{language.created_title[language_id]}}</h1>
      <img class="m-auto mb-8 w-52" src="../../assets/images/airballoon.png">
      <p class="mb-4">{{language.created_desc[language_id]}}</p>
    </div>
    <!-- if patient facing form -->
    <div v-if="!patient.no_connections_app && patientSetup">
      <h1 class="text-xl font-bold mb-2" :class="[!isCompanion ? 'light-blue' : 'green']">{{ language.success[language_id] }}</h1>
      <p class="mb-4" :class="[!isCompanion ? 'light-blue' : 'green']">{{language.smartphone_download_now[language_id]}}</p>
      <a
        :href="isCompanion ? 'https://link.companion.health' : language.connections_link[language_id]"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          class="m-auto mb-8 mt-4 cursor-pointer" width="50%"
          :src="isCompanion
            ? require('@/assets/images/companion-download-image.png')
            : require(`@/assets/images/${language.download_link_image[language_id]}`)"
          alt="App Download Image"
        />
      </a>
      <p class="mb-2" :class="[!isCompanion ? 'light-blue' : 'green']">{{language.login_first_time[language_id]}}</p>
      <p class="mb-2 text-lg font-bold">{{language.or[language_id]}}</p>
      <p class="text-lg font-bold">{{language.open_text_message[language_id]}}</p>
      <p :class="[!isCompanion ? 'light-blue' : 'green']">{{language.tap_link[language_id]}}</p>
      <p :class="[!isCompanion ? 'light-blue' : 'green']">{{language.login_first_time[language_id]}}</p>
      <p class="mb-4 mt-8">{{ language.contact_help[language_id] }}<a :class="[!isCompanion ? 'light-blue' : 'green']"
          :href="isCompanion ? 'mailto:support@companion.health' : 'mailto:support@connectionsapp.com'">{{ isCompanion ? 'support@companion.health' : 'support@connectionsapp.com' }}</a>{{ language.for_help[language_id] }}</p>
    </div>
    <!-- if staff enrollment form with staff assigned-->
    <div v-if="!patient.no_connections_app && !patient.temp_pass && !patientSetup ">
      <h1 class="text-xl font-bold" :class="!isCompanion ? 'light-blue' : 'green'">
        {{ headerText }}
      </h1>
      <p v-if="!onboarded" class="mb-4">{{language.based_phone_dob[language_id]}}</p>

      <img class="m-auto mb-8 mt-4 w-52" src="../../assets/images/enrolled.png">

      <p class=" mb-4 text-xl font-bold" :class="!isCompanion ? 'light-blue' : 'green'">
        {{onboarded ? language.message_text_sent_onboarded[language_id] : enrolled ? language.message_text_sent_enrolled[language_id] : language.message_text_sent[language_id] }}
      </p>        
      <p class="mb-4">
        {{ onboarded
          ? language.download_link_onboarded[language_id]
          : language.download_link[language_id]
        }}
        <a
          :class="[!isCompanion ? 'light-blue' : 'green']"
          :href="isCompanion ? 'https://link.companion.health' : language.connections_link[language_id]"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ isCompanion ? 'https://link.companion.health' : language.connections_link[language_id] }}
        </a>
      </p>
      <p class="mb-4">{{isCompanion ? language.check_spam_companion[language_id] : language.check_spam[language_id] }}</p>
      <p class="mb-4">{{ language.contact[language_id] }}<a :class="[!isCompanion ? 'light-blue' : 'green']"
          :href="isCompanion ? 'mailto:support@companion.health' : 'mailto:support@connectionsapp.com'">{{ isCompanion ? 'support@companion.health' : 'support@connectionsapp.com' }}</a>{{ language.assistance[language_id] }}</p>
      <button class="w-24" :class="{compbutton: isCompanion}" @click="closeModal">{{ language.close[language_id] }}</button>
    </div>
    <!-- if staff enrollment form with no staff assigned-->
    <div v-if="!patient.no_connections_app && !patientSetup && patient.temp_pass">
      <h1 class="text-3xl font-bold mb-2" :class="[!companion ? 'light-blue' : 'green']">{{ language.enrolled[language_id] }}</h1>
      <img class="m-auto mb-8 w-52" src="../../assets/images/enrolled.png">
      <p class=" mb-4 text-xl font-bold" :class="!isCompanion ? 'light-blue' : 'green'">
        {{language.message_text_sent[language_id] }}
      </p>        
      <p class="mb-4">
        {{ language.download_link[language_id]
        }}
        <a
          :class="[!isCompanion ? 'light-blue' : 'green']"
          :href="isCompanion ? 'https://link.companion.health' : language.connections_link[language_id]"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ isCompanion ? 'https://link.companion.health' : language.connections_link[language_id] }}
        </a>
      </p>
      <p class="mb-4">{{isCompanion ? language.check_spam_companion[language_id] : language.check_spam[language_id] }}</p>
      <p class="mb-4">{{ language.contact[language_id] }}<a :class="[!isCompanion ? 'light-blue' : 'green']"
          :href="isCompanion ? 'mailto:support@companion.health' : 'mailto:support@connectionsapp.com'">{{ isCompanion ? 'support@companion.health' : 'support@connectionsapp.com' }}</a>{{ language.assistance[language_id] }}</p>
      <button class="w-24" :class="{compbutton: isCompanion}" @click="closeModal">{{ language.close[language_id] }}</button>
    </div>
  </modal>
</template>

<script>
import { translations } from '../../translations'

export default {
  name: 'SuccessModal',
  components: { // imported components
  },
  props: { // props passed into component
    patient: Object,
    isCompanion: Boolean ?? false,
    patientSetup: Boolean ?? false,
    language_id: Number,
    onboarded: Boolean ?? false,
    enrolled: Boolean ?? false
  },
  data() { // component props
    return {
      language: translations(),
      loading: false
    }
  },
  created() {
    this.language_id = this.patientSetup ? this.patient.language_id : this.language_id;
    this.steps = [
      this.language.steps_view[this.language_id],
      this.language.steps_tap[this.language_id],
      this.language.steps_download[this.language_id],
      this.language.steps_login[this.language_id]
    ];
  },
  mounted() { /* Called after the instance has been mounted */ },
  computed: {
    headerText() {
      const fullName = `${this.patient?.first_name ?? ''} ${this.patient?.last_name ?? ''}`.trim();
      const statusText = this.isCompanion ? (this.onboarded
        ? this.language.already_enrolled_onboarded_companion[this.language_id]
        : this.language.already_enrolled_not_onboarded_companion[this.language_id]) : (this.onboarded
        ? this.language.already_enrolled_onboarded[this.language_id]
        : this.language.already_enrolled_not_onboarded[this.language_id]);
      return `${fullName} ${statusText}`;
    }
  },
  methods: { // component functions
    closeModal() {
      this.$emit('close-modal');
      this.$modal.hide('success');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.link {
  margin-left: 50px;
  margin-right: 50px;
}

button {
  height: 40px;
  font-size: 14px;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 40px;
  background: #750097
}

.compbutton {
  background: #2c6759;
}

button.send {
  border-radius: 4px;
}

.light-blue {
  color: #750097;
}
.green{
  color:#2c6759;
}

.dark-blue {
  color: #005AC0;
}

input {
  font-size: 14px;
  font-weight: 400;
  color: #333;
  height: 40px;
  border-radius: 4px;
  padding: 6px 12px;
  line-height: 1.42857143;
  border: 1px solid #ccc;
  -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
  -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;
  -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}

input:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
}

.container {
  display: inline-flex;
  justify-content: center;
  width: 200px;
}

.centered-list {
  list-style-type: decimal;
  padding-left: 40px;
  margin: 0;
  text-align: left;
}
</style>

<!-- Not "scoped" to style modal -->
<style>
.vm--container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.vm--overlay {
  background: rgba(8, 17, 53, 0.38) !important;
}

.vm--modal {
  text-align: center;
  border-radius: 4px !important;
  background: #ffffff;
  padding: 20px;
  height: auto !important;
  width: auto !important;
  max-width: 600px;
  top: auto !important;
  left: auto !important;
}
</style>
